import React, { useContext, useEffect, useState } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";
import "./DownloadProgress.css";

const DownloadProgress = () => {
  const {
    isDownloading,
    setIsDownloading,
    downloadProgress,
    updateDownloadProgress,
  } = useContext(CanvasContext);
  const [showCloseButton, setShowCloseButton] = useState(false);

  useEffect(() => {
    if (downloadProgress.percentage === 100) {
      setTimeout(() => {
        setShowCloseButton(true);
      }, 1000);
    }
  }, [downloadProgress.percentage]);

  const handleClose = () => {
    setIsDownloading(false);
    updateDownloadProgress({
      current: 0,
      total: 0,
      percentage: 0,
      remainingTime: 0,
    });
  };

  if (!isDownloading) {
    return null;
  }

  return (
    <div className="download-progress-overlay">
      <div className="download-progress-container fade-in">
        <h2 className="download-progress-title">
          {downloadProgress.percentage === 100
            ? "Download Complete!"
            : "Downloading Project"}
        </h2>
        {downloadProgress.percentage === 100 ? (
          <div className="download-complete-animation">
            <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
              <circle
                className="custom-circle"
                cx="50"
                cy="50"
                r="45"
                stroke="#4caf50"
                strokeWidth="5"
                fill="none"
              />
              <path
                className="custom-checkmark"
                d="M30 50 L45 65 L70 35"
                stroke="#4caf50"
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ) : (
          <>
            <div className="download-progress-bar">
              <div
                className="download-progress-bar-inner"
                style={{ width: `${downloadProgress.percentage}%` }}
              ></div>
            </div>
            <div className="download-progress-info">
              {/* <span>
                {(downloadProgress.current / 1024 / 1024).toFixed(2)} MB /{" "}
                {(downloadProgress.total / 1024 / 1024).toFixed(2)} MB
              </span> */}
              <span>{downloadProgress.percentage}%</span>
            </div>
            <p>
              Estimated time remaining:{" "}
              {Math.ceil(downloadProgress.remainingTime)} seconds
            </p>
          </>
        )}
        <div className="button-container">
          {downloadProgress.percentage === 100 && showCloseButton && (
            <button className="close-button" onClick={handleClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadProgress;
